namespace SPA
{
	export namespace Realtor
	{
		export namespace data
		{
			export class RealtorTableDataModel
				extends ui.table.model.AbstractTableModel<SPA.Realtor.RealtorObjectModel>
			{

				public constructor( descriptor?: ui.table.model.ITableModelDescriptor )
				{
					super( descriptor );

					this.ModelReader( new RealtorTableDataReader() );
				}

				public buildHeader(): JQuery<HTMLElement>
				{
					return new ui.base.BaseHTMLElement( 'tr' )
						.append( new ui.base.BaseHTMLElement( 'th' ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Realtor.TITLE.LIST.LONG.object_number' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Realtor.TITLE.LIST.LONG.address' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Realtor.TITLE.LIST.LONG.customer' ) ) )
					.Root();
				}

			}

			export class RealtorTableDataReader
				extends ui.table.DataReader<SPA.Realtor.RealtorObjectModel >
			{
				public constructor()
				{
					super();
				}

				public GenerateDataField( p_Data: SPA.Realtor.RealtorObjectModel ): JQuery<HTMLElement>
				{
					const link = $(
						new Button(
							{
								title: p_Data.ObjectNumber,
								style: 'link',
								on:
								{
									click: () =>
									{
										app.getGlobalTabControl().addTab(
											p_Data.ObjectNumber,
											new SPA.Realtor.Page(p_Data),
											true
										);
									}
								}
							}
						).getElement()
					).removeClass( 'btn' );

					const customer = new Wollmilch.Customer( p_Data.Contractor, p_Data.Customer );

					let cdisplay: string = '';
					if ( customer.isClient() )
					{
						const c = customer.Customer() as Wollmilch.ClientObject;

						cdisplay = ( c.Gender === 'f' ? 'Frau ' : 'Herr ' ) + c.Surname + ", " + c.Name;
					}
					else
					{
						const c = customer.Customer() as Wollmilch.CompanyObject;

						cdisplay = c.Name + " " + c.LegalForm;
					}

					return new ui.base.BaseHTMLElement( 'tr' )
						.append(
							// Aktionsbuttons oder so!!!
							new ui.base.BaseHTMLElement('td').append(
								$(new Button(
									{
										title: app.getSpanMessage('Aux.OPEN_BTN'),
										style: 'default',
										size: 'xs',
										on:
											{
												click: () => {
													link.trigger('click');
												}
											}
									}
									).getElement()
								)
							)
						)
						.append(
							new ui.base.BaseHTMLElement( 'td' ).append( link )
						)
						.append(
							new ui.base.BaseHTMLElement( 'td' ).append( p_Data.Address.display )
						)
						.append(
							new ui.base.BaseHTMLElement( 'td' ).append( cdisplay )
						)
					.Root();
				}
			}

		}
	}
}
